import Radio from '@mui/material/Radio';
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useMapStore } from "../..";
import BaseMap from "../../interfaces/BaseMap";
import Dropdown from "../Dropdown";
import BaseMapIcon from "../icons/BaseMapIcon";
import styles from './Header.module.css';

function BaseMapDropdown() {
    const mapStore = useMapStore();
    const [areBaseMapOpen, setAreBaseMapOpen] = useState(false);

    return (
        <Dropdown
            className={styles.dropdown}
            title="Base Map"
            isOpen={areBaseMapOpen}
            setIsOpen={setAreBaseMapOpen}
            icon={<BaseMapIcon />}
        >
            <ul>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.Streets} onClick={() => mapStore.setBaseMap(BaseMap.Streets)} /> Streets</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.SatelliteMapbox} onClick={() => mapStore.setBaseMap(BaseMap.SatelliteMapbox)} /> Satellite: Mapbox</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.SatelliteGoogle} onClick={() => mapStore.setBaseMap(BaseMap.SatelliteGoogle)} /> Satellite: Google</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.SatelliteArcGIS} onClick={() => mapStore.setBaseMap(BaseMap.SatelliteArcGIS)} /> Satellite: ArcGIS</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.SatelliteBing} onClick={() => mapStore.setBaseMap(BaseMap.SatelliteBing)} /> Satellite: Bing</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.SatelliteNAIP} onClick={() => mapStore.setBaseMap(BaseMap.SatelliteNAIP)} /> Satellite: NAIP</label></li>
                <li><label><Radio checked={mapStore.baseMap === BaseMap.HybridMapbox} onClick={() => mapStore.setBaseMap(BaseMap.HybridMapbox)} /> Hybrid: Mapbox</label></li>
            </ul>
        </Dropdown>
    );
}

export default observer(BaseMapDropdown);